<section class="header">
  <edge-global-header></edge-global-header>
</section>

<section class="hero">
  <edge-global-hero
    image="/assets/images/home/hero-bg.jpg"
    logo="/assets/images/goarmy-edge-logo.svg"
    [tagline]="tagline">
    <p>GoArmy Edge is a suite of free-to-use apps designed to help athletes and coaches learn and prepare in a virtual environment before taking the field.</p>
  </edge-global-hero>
</section>

<section class="carousel">
  <edge-home-carousel></edge-home-carousel>
</section>

<section class="content">
  <edge-home-content></edge-home-content>
</section>

<section class="platforms">
  <edge-global-platforms></edge-global-platforms>
</section>

<section class="testamonials">
  <edge-global-testamonials [testimonial]="testimonial" [author]="author"></edge-global-testamonials>
</section>

<section class="bottom">
  <edge-global-bottom></edge-global-bottom>
</section>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>
